import { useState, useEffect, useCallback } from 'react'
import api from '../services/api'
import { FeedItem } from '../types/feed'

interface UseFeedReturn {
  data: FeedItem[]
  isLoading: boolean
  error: string | null
  fetchFeedData: (page: number) => Promise<any>
  PAGE_SIZE: number
  hasMore: boolean
  loadMore: () => void
}

export function useFeed(): UseFeedReturn {
  const [data, setData] = useState<FeedItem[]>([])
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const PAGE_SIZE = 10
  const [page, setPage] = useState(1)
  const [hasMore, setHasMore] = useState(true)

  const fetchFeedData = useCallback(async (pageNum: number) => {
    console.log('🔍 fetchFeedData called with page:', pageNum)
    console.log('Current state:', { isLoading, hasMore, dataLength: data.length })
    
    setIsLoading(true)
    try {
      console.log('📡 Making API request for page:', pageNum)
      const response = await api.get('/api/v1/feed', {
        params: {
          page: pageNum,
          pageSize: PAGE_SIZE
        }
      })
      
      console.log('📥 Feed response:', response.data)
      
      const items = response.data.data || []
      console.log(`✨ Received ${items.length} items`)
      
      setData(prev => {
        const newData = pageNum === 1 ? items : [...prev, ...items]
        console.log('🔄 Updating data:', { 
          prevLength: prev.length, 
          newLength: newData.length 
        })
        return newData
      })
      setHasMore(response.data.hasMore)
      setPage(pageNum)
    } catch (error: any) {
      console.error('❌ Feed error:', error)
      setError(error?.message || 'Failed to fetch feed')
    } finally {
      setIsLoading(false)
    }
  }, [])

  const loadMore = useCallback(() => {
    console.log('📜 loadMore called:', { page, hasMore, isLoading })
    if (hasMore && !isLoading) {
      fetchFeedData(page + 1)
    }
  }, [fetchFeedData, page, hasMore, isLoading])

  useEffect(() => {
    console.log('🎬 Initial feed load')
    fetchFeedData(1)
  }, [fetchFeedData])

  return {
    data,
    isLoading,
    error,
    fetchFeedData,
    PAGE_SIZE,
    hasMore,
    loadMore
  }
} 